export enum GuestServiceStatusType {
  DoNotDisturb = 'doNotDisturb',
  ServiceDeferred = 'serviceDeferred',
  ServiceRefused = 'serviceRefused',
  ServiceRequested = 'serviceRequested'
}



// WEBPACK FOOTER //
// ./src/shared/enum/guestServiceStatusType.ts